import { ElementType } from 'react'

import { Text, TextProps } from '@lounge-fe/ui-kit/src/components/Text'

const Description = <E extends ElementType = 'p'>(props: TextProps<E>) => (
  <Text variant="body-sm" className="text-subtle" {...props} />
)

export default Description
